import { Box, CircularProgress } from "@mui/material";
import React from "react";

interface LoadingOverlayProps {
  loading: boolean;
  size?: number;
}

/**
 * A reusable loading overlay that covers its parent container with a semi-transparent backdrop
 * and displays a centered circular progress indicator.
 */
const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ loading, size = 40 }) => {
  if (!loading) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "action.hover",
        backdropFilter: "blur(1px)",
        zIndex: 1,
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};

export default LoadingOverlay;
